/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportSubmissionResource } from '../models/ReportSubmissionResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ReportSubmissionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les soumissions de rapports
     * Toutes les soumissions, sans filtre ni pagination.
     * @returns string
     * @throws ApiError
     */
    public submissionIndex(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/report/submission',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Detail d'une soumission
     * Les reponses donnees, question par question.
     * @param index
     * @returns ReportSubmissionResource `ReportSubmissionResource`
     * @throws ApiError
     */
    public submissionShow(
        index: string,
    ): CancelablePromise<ReportSubmissionResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/report/submission/{index}',
            path: {
                'index': index,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Soumettre un rapport
     * Malgre le verbe `PUT`, cree une **nouvelle** soumission du modele `{submission}` (identifiant du modele de rapport) par le personnel connecte. Corps : un objet `{ <id_question>: <reponse> }` ; chaque reponse est validee selon le type et les contraintes de sa question. En cas d'erreur, rien n'est enregistre (422 avec les erreurs par question).
     * @param reportId
     * @returns any
     * @throws ApiError
     */
    public submissionUpdate(
        reportId: string,
    ): CancelablePromise<({
        message: string;
    } | {
        message: string;
        errors: string;
    })> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/report/submission/{report_id}',
            path: {
                'report_id': reportId,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
